module.exports = __webpack_public_path__ + "img/energetic3.6961afff.png";